import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

export function useCsr(startDate, endDate) {
  const [data, setData] = useState({ csrs: [], totals: {}, warnings: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!startDate || !endDate) return;
    let cancelled = false;
    setLoading(true);
    setError(null);
    apiClient.get('/csr', { params: { startDate, endDate } })
      .then(r => { if (!cancelled) setData(r.data); })
      .catch(e => {
        if (cancelled) return;
        // Previously left the last successful range's numbers on screen after a failed
        // fetch for a NEW date range - showing "Failed to load" next to fully populated
        // cards made it look like the error was cosmetic when the numbers underneath were
        // actually stale (belonged to whatever range loaded before this one failed).
        setData({ csrs: [], totals: {}, warnings: [] });
        setError(e.response?.data?.error || e.message || 'Failed to load CSR data');
      })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [startDate, endDate]);

  return { ...data, loading, error };
}
